import { stripDataUrlPrefix } from './format.js';

const MAX_IMAGE_SIDE = 1920;
const COMPRESS_THRESHOLD_BYTES = 1_500_000;
const JPEG_QUALITY = 0.88;

function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error('读取图片失败'));
    reader.readAsDataURL(file);
  });
}

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), type, quality);
  });
}

async function compressImageFile(file) {
  if (file.size <= COMPRESS_THRESHOLD_BYTES) return null;
  if (!/^image\/(?:png|jpe?g|webp)$/i.test(file.type || '')) return null;
  let bitmap = null;
  try {
    bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_IMAGE_SIDE / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d', { alpha: false });
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(bitmap, 0, 0, width, height);
    const blob = await canvasToBlob(canvas, 'image/jpeg', JPEG_QUALITY);
    if (!blob || blob.size >= file.size) return null;
    return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
  } catch {
    return null;
  } finally {
    bitmap?.close?.();
  }
}

export async function convertFiles(files) {
  const out = [];
  for (const file of files) {
    if (!file.type.startsWith('image/')) continue;
    const normalizedFile = await compressImageFile(file) || file;
    const dataUrl = await readFileAsDataUrl(normalizedFile);
    out.push({
      name: normalizedFile.name,
      mimeType: normalizedFile.type || 'image/png',
      dataUrl,
      base64: stripDataUrlPrefix(dataUrl),
      originalName: file.name,
      originalSize: file.size,
      size: normalizedFile.size,
    });
  }
  return out;
}
